/*
 * @Description: 实时定位驾驶舱 — B4「轨迹统计」数据 hook（回放页 4 数据格）
 */
import { useEffect, useRef, useState } from 'react'
import { useAppDispatch } from '../../../app/hooks'
import { fetchTrackStats } from '../../../actions/locationCockpit'
import { isCockpitMockEnabled } from '../constants'
import { getMockTrackStats } from '../mock/stats.mock'
import { CockpitEnvelope, TrackStatsData } from '../types/cockpit.types'

export interface UseTrackStatsResult {
  stats: TrackStatsData | null
  loading: boolean
}

/**
 * 拉取单成员当日轨迹统计（B4，4 数据格）。userId / 时间范围变化时重新拉取。
 *
 * @param groupId - 当前团队长 id
 * @param userId - 成员 userId
 * @param startSec - 起始时间，unix 秒
 * @param endSec - 结束时间，unix 秒
 */
export function useTrackStats(
  groupId: string,
  userId: string,
  startSec: number,
  endSec: number
): UseTrackStatsResult {
  const dispatch = useAppDispatch()
  const isMock = isCockpitMockEnabled()
  const [stats, setStats] = useState<TrackStatsData | null>(null)
  const [loading, setLoading] = useState(false)
  const aliveRef = useRef(true)

  useEffect(() => {
    aliveRef.current = true

    if (isMock) {
      setStats(getMockTrackStats())
      return () => {
        aliveRef.current = false
      }
    }
    if (!groupId || !userId || !startSec || !endSec) {
      return () => {
        aliveRef.current = false
      }
    }

    setLoading(true)
    dispatch(
      fetchTrackStats({ groupId, userId, startTime: startSec, endTime: endSec })
    )
      .then((res: CockpitEnvelope<TrackStatsData>) => {
        if (!aliveRef.current) return
        setLoading(false)
        if (res && res.code === 200) {
          setStats(res.data ?? null)
        }
      })
      .catch(() => {
        if (!aliveRef.current) return
        setLoading(false)
      })

    return () => {
      aliveRef.current = false
    }
  }, [dispatch, groupId, userId, startSec, endSec, isMock])

  return { stats, loading }
}
